import { ButtonProps } from '../Button';

export function getSpinnerSize(size: NonNullable<ButtonProps['size']>): number {
    switch (size) {
        case 'medium':
            return 14;
        case 'small':
            return 12;
    }
}
